import { useEffect, useRef, } from 'react';
import { depsEqual, } from '../utils/ReactUtils.js';
/**
 * like useEffect, but runs only when deps change
 */
export function useUpdateEffect(effect, deps) {
    const prevDeps = useRef(null);
    useEffect(() => {
        if (prevDeps.current === null) {
            prevDeps.current = deps;
            return;
        }
        // filters StrictMode mount re-run
        if (depsEqual(prevDeps.current, deps)) {
            return;
        }
        prevDeps.current = deps;
        return effect();
    }, deps);
}
//# sourceMappingURL=useUpdateEffect.js.map